<script lang="ts" setup>
// @ts-ignore
import DOMPurify from "dompurify";

const props = defineProps({
  token: {
    type: Object as PropType<ParagraphToken>,
    required: false,
  },
});

const documentId = inject("documentId") as any;

const documentShowFormattingStore = useDocumentShowFormattingStore(documentId);
const { shouldShowFormatting } = storeToRefs(documentShowFormattingStore);

const documentSelectionStore = useDocumentSelectionStore(documentId);
const { isTokenSelected } = storeToRefs(documentSelectionStore);

const isYellowHighlight = computed(() => {
  return matchingToken.value?.formatting?.highlightColor == "DARK_YELLOW";
});

const isGreenHighlight = computed(() => {
  return matchingToken.value?.formatting?.highlightColor == "BRIGHT_GREEN";
});

const isBlueHighlight = computed(() => {
  return matchingToken.value?.formatting?.highlightColor == "BLUE";
});

const matchingToken = computed(() => {
  return props.token;
});

// right I think the problem is that mabne html instead?
const tokenContent = computed(() => {
  if (shouldShowFormatting.value != true)
    return matchingToken.value?.text
      .replace(/\t/g, "&nbsp;&nbsp;&nbsp;&nbsp;")
      .replace(/\n/g, "");

  if (matchingToken.value?.type == "filler")
    return " <span class='text-danger-default text-[10px]'>•</span> ";

  return matchingToken.value?.text.replace(
    /\t/g,
    "<span class='text-danger-default text-[10px]'>→</span>"
  );
});

const appUserDataStore = useAppUserDataStore();
const { commentColor } = storeToRefs(appUserDataStore);

const highlightColor = computed(() => {
  return useTokenHighlightColor(
    matchingToken.value?.formatting?.highlightColor
  );
});
</script>

<template>
  <span
    :class="{
      'leading-[1.0]': true,
      'underline decoration-2': matchingToken?.formatting?.underline,
      'font-[600]': matchingToken?.formatting?.bold,
      italic: matchingToken?.formatting?.italic,
      'line-through decoration-2': matchingToken?.formatting?.strikeThrough,
      ' bg-yellow-100': isYellowHighlight,
      ' bg-green-200': isGreenHighlight,
      ' bg-blue-100': isBlueHighlight,
    }"
    :style="{
      'font-size': matchingToken?.formatting?.size
        ? matchingToken?.formatting?.size + 'pt'
        : '12pt',
      color: useArrayToRGB(matchingToken?.formatting?.color ?? []),
      'white-space': 'pre',
      'text-decoration-color': useRGBToHex(commentColor),
      'background-color': highlightColor,
    }"
    v-html="DOMPurify.sanitize(tokenContent)"
  >
  </span>
</template>

<style scoped></style>
